// Module
var code = "<div>\n <assortment-planning></assortment-planning>\n</div>\n";
// Exports
module.exports = code;